 /*******************系统管理*******************/
 const dictionarytype = resolve => require(['@/pages/system/dictionarytype'], resolve);
 const dictionary = resolve => require(['@/pages/system/dictionary'], resolve);
 const persons = resolve => require(['@/pages/system/persons'], resolve);
 const message = resolve => require(['@/pages/system/message'], resolve);
 const createMessage = resolve => require(['@/pages/system/message/createMessage.vue'], resolve);
 const role = resolve => require(['@/pages/system/role'], resolve);

 export default [
   //角色权限管理
   {
     path: "/role",
     name: "角色权限管理",
     component: role
   },
   //人员管理
   {
     path: "/persons",
     name: "人员管理",
     component: persons
   },
   {
      path: "/message",
      name: "消息管理",
      component: message,
       meta: {
         keepAlive: true
       }
   },
   {
      path: "/message/createMessage/:type/:Id",
      name: "创建推送",
      component: createMessage
   },
   {
     path: "/dictionary",
     name: "数据字典管理",
     component: dictionary
   },
   {
     path: "/dictionarytype",
     name: "字典类型管理",
     component: dictionarytype
   }
 ]
